import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  url = ConfigService.toApiUrl("v1/notifications/");

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<any[]>(`${this.url}`);
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  store(ressource: any) {
    return this.http.post<any>(`${this.url}`, ressource, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  deleteAll() {
    return this.http.post<any>(`${ConfigService.toApiUrl("v1/notifications-delete-all")}`, {}, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }
}
